import { SubscriptionType } from '../common/interfaces';

/**
 * Check if an offerId has chegg study
 */
var subscriptionHasCheggStudy = function subscriptionHasCheggStudy(offerId) {
  return offerId === SubscriptionType.CHEGG_STUDY || offerId === SubscriptionType.CHEGG_STUDY_V2 || offerId === SubscriptionType.CHEGG_STUDY_6_MONTH || offerId === SubscriptionType.CHEGG_STUDY_12_MONTH;
};
export default subscriptionHasCheggStudy;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/commerce-utils/dist/esm/utils/subscriptionHasCheggStudy.js
// module id = 4128
// module chunks = 11